import React from "react";
import { Link } from "react-router-dom";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";
import Header from "../components/Header.js";

function Thank() {
  return (
    <Translation>
      {t => (
        <div id="main">
          <Header />
          <div id="wrap">
            <div id="focus">
              <h1>{t("thank.thank_you")}</h1>
              <p>{t("thank.thank_cooperation")}</p>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Thank;
